import React from "react"
import { graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import Title from "../common/title"
import { useIntl } from "gatsby-plugin-react-intl"
import Obfuscate from "react-obfuscate"
import HTMLReactParser from "html-react-parser"

const BlockInfo = ({ info }) => {
  const intl = useIntl()

  const daysInfo = info.days
  const hoursInfo = info.opening_hours

  const concatArr = (daysInfo, hoursInfo, sep) =>
    daysInfo.map(function (num, idx) {
      if (hoursInfo[idx]) {
        return num.toString().concat(sep, hoursInfo[idx].toString())
      }
      return num.toString()
    })

  const arrayHours =
    intl.locale === "fr"
      ? concatArr(daysInfo, hoursInfo, " : ")
      : concatArr(daysInfo, hoursInfo, ": ")

  return (
    <section className="blk-spacing blk-infos-pra">
      <Container>
        <Row>
          <Row>
            <Col md={12} xs={12}>
              <Title
                heading={3}
                text={intl.formatMessage({
                  id: "practical_info.title",
                })}
              />
            </Col>
          </Row>
          <Row>
            {info.duration && (
              <Col md={6} xs={12}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({ id: "practical_info.duration" })}
                  </p>
                  <span className="info-detail">{HTMLReactParser(info.duration)}</span>
                </div>
              </Col>
            )}
            {info.pricing_details && (
              <Col md={6}>
                <div className="info-content price">
                  <p className="description">
                    {intl.formatMessage({ id: "practical_info.price" })}
                  </p>
                  <span className="info-detail">
                    {HTMLReactParser(info.pricing_details.processed)}
                  </span>
                </div>
              </Col>
            )}
          </Row>
          <Row>
            {info.location && (
              <Col md={6} xs={12} className="info_details">
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({
                      id: "practical_info.location",
                    })}
                  </p>
                  <span className="info-detail">{info.location.title}</span>
                </div>
              </Col>
            )}
            {info.number_of_persons && (
              <Col md={6} xs={12}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({
                      id: "practical_info.number_of_people",
                    })}
                  </p>
                  <span className="info-detail">{HTMLReactParser(info.number_of_persons)}</span>
                </div>
              </Col>
            )}
          </Row>
          <Row>
            {info.email && (
              <Col md={6} xs={12}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({ id: "practical_info.email" })}
                  </p>
                  <span className="info-detail">
                    <Obfuscate email={info.email} />
                  </span>
                </div>
              </Col>
            )}
            {info.dress_code && (
              <Col md={6} xs={12}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({ id: "practical_info.dress_code" })}
                  </p>
                  <span className="info-detail">{HTMLReactParser(info.dress_code)}</span>
                </div>
              </Col>
            )}
          </Row>
          <Row>
            {info.recommendation && (
              <Col md={6} xs={12}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({
                      id: "practical_info.recommendation",
                    })}
                  </p>
                  <span className="info-detail">{info.recommendation}</span>
                </div>
              </Col>
            )}
            {info.what_to_bring && (
              <Col md={6}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({
                      id: "practical_info.what_to_bring",
                    })}
                  </p>
                  <span className="info-detail">{info.what_to_bring}</span>
                </div>
              </Col>
            )}
          </Row>
          <Row>
            {info.telephone && (
              <Col md={6} xs={12}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({
                      id: "practical_info.telephone",
                    })}
                  </p>
                  <span className="info-detail">{info.telephone}</span>
                </div>
              </Col>
            )}
            {daysInfo.length > 0 || hoursInfo.length > 0 ? (
              <Col md={6} xs={12}>
                <div className="info-content">
                  <p className="description">
                    {intl.formatMessage({ id: "practical_info.schedule" })}
                  </p>
                  {arrayHours.map((hour, index) => {
                    return (
                      <div>
                        <span key={index} className="info-detail">
                          {hour}
                        </span>
                        <br />
                      </div>
                    )
                  })}
                </div>
              </Col>
            ) : (
              <>
                {hoursInfo.length > 0 && (
                  <Col md={6} xs={12}>
                    <div className="info-content">
                      <p className="description">
                        {intl.formatMessage({
                          id: "practical_info.schedule",
                        })}
                      </p>
                      <span className="info-detail">{hoursInfo[0]}</span>
                    </div>
                  </Col>
                )}
              </>
            )}
          </Row>
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment infoPratique on paragraph__information_pratique {
    internal {
      type
    }
    email
    fixed_experience_price
    telephone
    number_of_persons
    opening_hours
    days
    dress_code
    duration
    price
    price_child
    what_to_bring
    recommendation
    pricing_details {
      processed
    }
    location {
      title
      uri
      url
    }
  }
`

export default BlockInfo
